import type { SVGProps } from 'react';
const SvgGolfCourse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#golf_course_svg__a)">
      <path d="M19.5 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17 5.92 9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06Z" />
    </g>
    <defs>
      <clipPath id="golf_course_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGolfCourse;
